var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('apex-charts',{attrs:{"type":"donut","height":_vm.height,"width":_vm.width,"options":_vm.chartOptions,"series":_vm.series}}),_vm._v(" "),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }